import { render, staticRenderFns } from "./CategoryIcon.vue?vue&type=template&id=76d282b0&scoped=true&"
import script from "./CategoryIcon.vue?vue&type=script&lang=js&"
export * from "./CategoryIcon.vue?vue&type=script&lang=js&"
import style0 from "./CategoryIcon.vue?vue&type=style&index=0&id=76d282b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d282b0",
  null
  
)

export default component.exports